import { PaginationV2 } from '@pickleballinc/react-ui';
import { useRouter, useSearchParams } from 'next/navigation';

interface VideosPaginationProps {
  totalRecords: number;
  pageSize: number;
}

const VideosPagination = ({ totalRecords, pageSize }: VideosPaginationProps) => {
  const router = useRouter();
  const searchParams = useSearchParams();

  const page = Number(searchParams?.get('page') || 1);
  const tournament = searchParams?.get('tournament') || 'all';
  return (
    <div className='my-6'>
      <PaginationV2
        totalNumberOfPages={Math.ceil(totalRecords / pageSize)}
        currentPage={page}
        onPreviousClick={() => router.replace(`?tournament=${tournament}&page=${page - 1}`)}
        onNextClick={() => router.replace(`?tournament=${tournament}&page=${page + 1}`)}
        onPageClick={(newPage) => router.replace(`?tournament=${tournament}&page=${newPage}`)}
      />
    </div>
  );
};

export default VideosPagination;
